"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var Changelogs_1 = require("../components/Changelogs");
var SingleChangelog_1 = require("../components/SingleChangelog");
var WidgetComponent = function (props) {
    var organization = props.organization, organizationError = props.organizationError, changelogsData = props.changelogsData, changelogsLoading = props.changelogsLoading, changelogsError = props.changelogsError, config = props.config, stage = props.stage, handleStageChange = props.handleStageChange;
    var _a = hooks_1.useState(null), stageProps = _a[0], setStageProps = _a[1];
    var handleStageToggle = function (nextStage, stageProps) {
        setStageProps(stageProps);
        return handleStageChange(nextStage);
    };
    var renderStageComponent = function () {
        var componentProps = {};
        var Component = Changelogs_1.default;
        switch (stage) {
            case 1: {
                Component = Changelogs_1.default;
                componentProps = {
                    toggleStage: handleStageToggle,
                    organization: organization,
                    stage: stage,
                    data: changelogsData,
                    loading: changelogsLoading,
                    error: changelogsError,
                };
                break;
            }
            case 2: {
                Component = SingleChangelog_1.default;
                componentProps = {
                    organization: organization,
                    stage: stage,
                    stageProps: stageProps,
                    config: config,
                };
                break;
            }
            default: {
                Component = Changelogs_1.default;
                componentProps = {
                    toggleStage: handleStageToggle,
                    organization: organization,
                    stage: stage,
                    data: changelogsData,
                    loading: changelogsLoading,
                    error: changelogsError,
                };
                break;
            }
        }
        return preact_1.h(Component, tslib_1.__assign({}, componentProps));
    };
    return preact_1.h(preact_1.Fragment, null, renderStageComponent());
};
exports.default = WidgetComponent;
